<!-- Device count label with info modal trigger -->
<div class="device-count-row">
  <label class="form-label">
    {{ 'costEdit.deviceCount' | translate }}
    <button class="info-button" type="button" (click)="openDeviceInfo()">
      <i class="fa-solid fa-circle-info"></i>
    </button>
  </label>
  <div class="only-label-display">{{ deviceCount }}</div>
</div>

<!-- Selected devices modal -->
@if (showDeviceInfoModal) {
  <div class="confirm-overlay" (click)="closeDeviceInfo()"></div>
  <div class="confirm-dialog device-info-dialog" [ngClass]="theme.getThemeClass()">
    <button class="modal-close" type="button" (click)="closeDeviceInfo()">×</button>
    <div class="confirm-message modal-title">
      {{ 'invoiceGeneration.selectedDevices' | translate }}
    </div>
    <div class="device-info-table">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>{{ 'iotTabHeaderDevice' | translate }}</th>
            <th>{{ 'address' | translate }}</th>
            <th>{{ 'binListViewUsage' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of devices; track row.thingName) {
            <tr>
              <td>{{ row.thingName }}</td>
              <td>{{ row.address }}</td>
              <td>{{ row.usageLabel }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="confirm-actions">
      <button class="btn btnCancel fixed-size" (click)="closeDeviceInfo()">
        {{ 'iotModalButtonClose' | translate }}
      </button>
    </div>
  </div>
}
